<template>
  <div class="col-md-12 mr-auto ml-auto">
    <div class="wizard-container">
      <div
        class="card card-wizard active"
        data-color="purple"
        id="wizardProfile"
      >
        <div class="card-header">
          <h4 class="card-title">
            Banner
          </h4>
        </div>
        <div class="card-body">
          <b-form @submit.prevent="save" v-if="!isLoading">
            <b-form-group>
              <b-form-group
                label="Titulo"
                description="Aparecerá no meio do banner"
               
              >
                <b-form-input
                  v-model="form.title"
                  type="text"
                  placeholder="Título"
                />
              </b-form-group>

              <b-form-group
                label="Subtitulo"
                description="Frase logo abaixo do titulo, no banner"
               
              >
                <form-editor :form="form" field="subtitle" />
              </b-form-group>

              <b-form-group
                label="Link"
                description="Página a ser mostrada ao clicar no título"
               
              >
                <b-form-input
                  v-model="form.link"
                  type="text"
                  placeholder="Título"
                />
              </b-form-group>

              <pictures-upload
                :form="form"
                field="image"
                url="uploads/images"
                required
                :multiple="false"
                label="Foto do Banner"
              />
              <div class="card-footer">
                <form-submit
                  :errors="error"
                  :sending="isSending"
                  label="Salvar"
                 
                />
              </div>
            </b-form-group>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormEditor from "@/components/FormEditor";
import PicturesUpload from "@/components/PicturesUpload";
import FormSubmit from "@/components/FormSubmit";
import axios from "axios";

export default {
  name: "BannerForm",
  data() {
    return {
      form: {
        title: "",
        subtitle: "",
        image: {},
        link: ""
      }
    };
  },
  created() {
    this.edit();
  },

  methods: {
    edit() {
      this.isLoading = true;
      axios
        .get("banner/1", {})
        .then(response => {
          this.apiDataToForm(this.form, response.data);
          this.isLoading = false;
        })
        .catch(this.showError);
    },
    save() {
      this.$validator.validate().then(isValid => {
        if (isValid) {
          this.isSending = true;
          this.error = false;
          axios({
            method: "PUT",
            url: "banner/1",
            data: this.form
          })
            .then(resp => {
              var banner = resp.data;
              if (banner && banner._id) {
                this.notify("O banner foi salvo!");
                window.scrollTo(0, 0);
              }
              this.isSending = false;
            })
            .catch(this.showError);
        }
      });
    }
  },
  components: {
    FormEditor,
    PicturesUpload,
    FormSubmit
  }
};
</script>
